import { queryKeys } from '@/src/api/queryKeys'
import { ONE_MINUTE_IN_MS } from '@/src/utils/constants'
import { useQuery } from '@tanstack/react-query'
import { API } from '../api/api'

export const useCompanyLogo = (companyId?: number, logoId?: number | null) => {
  return useQuery({
    queryKey: queryKeys.company.logo.toKeyWithArgs({ companyId, logoId }),
    enabled: !!companyId,
    staleTime: ONE_MINUTE_IN_MS * 5,
    retry: (failureCount, error: any) => {
      if (error?.response?.status === 404) return false
      return failureCount < 3
    },
    queryFn: async () => {
      if (!companyId || !logoId) return ''
      const logo = (await API.company.getLogo({ companyId })) as Blob
      return logo ? URL.createObjectURL(logo) : ''
    },
  })
}

export const useCompanyWhiteLabelLogo = (companyId?: number, whiteLabelLogoId?: number | null) => {
  return useQuery({
    queryKey: queryKeys.company.whiteLabelLogo.toKeyWithArgs({ companyId, whiteLabelLogoId }),
    enabled: !!companyId,
    staleTime: ONE_MINUTE_IN_MS * 5,
    retry: (failureCount, error: any) => {
      if (error?.response?.status === 404) return false
      return failureCount < 3
    },
    queryFn: async () => {
      if (!companyId || !whiteLabelLogoId) return ''
      const logo = (await API.company.getWhiteLabelLogo({ companyId })) as Blob
      return logo ? URL.createObjectURL(logo) : ''
    },
  })
}
